import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Heading3, StackView, Text } from 'localmed-core';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DiButton } from '../../../../../shared/components/DiComponents';
import { DiFailure } from '../../../../../shared/components/DiLayout';
import Calendar from '../../../../assets/Calendar-fill.gif';
import { IStepProps } from '../schedulingWizard';
import { Wrapper } from '../styles';

interface Props extends IStepProps {
  redirect?: boolean;
}

const Image = styled('img')`
  height: 250px;
`;

export default function SchedulingProgressStep({ wizard }: Props) {
  useEffect(() => {
    if (wizard) {
      wizard.handleSubmit();
      if (wizard.trackSchedulingEvent) {
        wizard.trackSchedulingEvent('Scheduling In Progress', 'SchedulingProgressStep');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { submitting, submitErrors, valid } = wizard?.form.getState() || {};
  useEffect(() => {
    if (wizard && !valid) {
      wizard.gotoStep('PATIENT_INFO_FORM_SCREEN');
    }
  }, [valid]);

  useEffect(() => {
    if (wizard && wizard.trackSchedulingEvent && submitErrors) {
      wizard.trackSchedulingEvent('Appointment Scheduling Error', 'SchedulingProgressStep', {
        errors: submitErrors,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitErrors]);
  if (!wizard) return null;

  const { office } = wizard.values;
  if (submitErrors && !submitting) {
    return (
      <Wrapper justifyContent="center" alignItems="center">
        <DiFailure title="Ooops we ran into a problem scheduling your appointment.">
          <Text>
            <FormattedMessage
              id="scheduling.SchedulingPage.PageNotFoundMessage"
              defaultMessage="Click the retry button, but if the problem continues to happen give us a call at {phoneNumber} and we will get you taken care of."
              values={{
                phoneNumber: office.phone,
              }}
            />
          </Text>
          <DiButton onClick={() => wizard.handleSubmit()} size="xl" mt="xl">
            Retry
          </DiButton>
        </DiFailure>
      </Wrapper>
    );
  }

  return (
    <Wrapper justifyContent="center" alignItems="center">
      <StackView
        spacing="md"
        css={css`
          text-align: center;
        `}
      >
        <Image src={Calendar} alt="Di logo animation" />
        <Heading3>
          <FormattedMessage
            id="scheduling.SchedulingProgressStep.bookingInProgressMessage"
            defaultMessage="Booking your appointment…"
          />
        </Heading3>
      </StackView>
    </Wrapper>
  );
}

SchedulingProgressStep.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  id: 'SCHEDULING_PROGRESS_STEP',
};
